export default "__VITE_ASSET__LzOs6jmX__"